import React from 'react'
import PropTypes from 'prop-types'
import { Form, Input } from 'antd'
import css from './Form.css'

const RemindersMessageReport = ({
  help,
  key,
  label,
  name,
  onChange,
  placeholder,
  value,
}) => (
  <Form.Item label={label} className={css.itemLabel} help={help} key={key}>
    <Input
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      className={css.input}
      name={name}
    />
  </Form.Item>
)

RemindersMessageReport.propTypes = {
  help: PropTypes.string,
  key: PropTypes.string.isRequired,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
}

RemindersMessageReport.defaultProps = {
  help: null,
  label: null,
  name: null,
  placeholder: null,
  value: null,
}

export default RemindersMessageReport



// WEBPACK FOOTER //
// ./src/common/RemindersMessageReport.js